import { render, staticRenderFns } from "./LongTextComponent.vue?vue&type=template&id=0cd7a297"
import script from "./LongTextComponent.vue?vue&type=script&lang=js"
export * from "./LongTextComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports